<div class="keys" (mousedown)="backdrop.press($event)" (click)="onBackdropClick($event)">
  <div
    #dialog
    class="keys__sheet"
    role="dialog"
    aria-modal="true"
    aria-labelledby="bk-keys-title"
    (keydown)="onKeydown($event)"
  >
    <header class="keys__head">
      <h2 class="bk-heading keys__title" id="bk-keys-title">Keyboard shortcuts</h2>
      <button #closeButton type="button" class="bk-icon-btn" aria-label="Close keyboard shortcuts" (click)="close()">
        <span class="bk-sym" aria-hidden="true">close</span>
      </button>
    </header>

    @for (group of groups; track group.title) {
      <section class="keys__group">
        <h3 class="bk-eyebrow keys__group-title">{{ group.title }}</h3>
        <dl class="keys__list">
          @for (shortcut of group.shortcuts; track shortcut.label) {
            <div class="keys__row">
              <dt class="keys__label">{{ shortcut.label }}</dt>
              <dd class="keys__combo">
                @for (key of shortcut.keys; track $index) {
                  <kbd>
                    @if (key.spoken) {
                      <span aria-hidden="true">{{ key.glyph }}</span>
                      <span class="bk-sr-only">{{ key.spoken }}</span>
                    } @else {
                      {{ key.glyph }}
                    }
                  </kbd>
                }
              </dd>
            </div>
          }
        </dl>
      </section>
    }
  </div>
</div>
